module.exports = __webpack_public_path__ + "static/media/design-sprint.44b7007a.svg";